var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuotes = function SvgQuotes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "var(--svg-stroke-color, inherit)",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "inherit",
    clipPath: "url(#quotes_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.429 4.286H5.143c-.947 0-1.714.767-1.714 1.714V21.43c0 .946.767 1.714 1.714 1.714h10.286c.946 0 1.714-.768 1.714-1.714V6c0-.947-.768-1.714-1.714-1.714M6.857 8.571h6.858M6.857 12.857h6.858M6.857 17.143h3.429"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.714.857h11.143a1.714 1.714 0 0 1 1.714 1.714v16.286"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "quotes_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgQuotes;